export default "/_next/static/media/landing-hero-desk.e846aec77a13670b7037f1c7b4a14dcc.mp4";